import React, { Dispatch, SetStateAction, useState } from "react";
import { IClient } from "../../../../models/client";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux";
import useWindowSize from "../../../../hooks/useWindowSize";
import LineMenu from "../LineMenu";
import {
  deleteClient,
  fetchClients,
  setCurrentPage,
} from "../../../../store/actions/clientActions";
import Modal from "../../modals/Modal";
import ModalEditClient from "../../modals/ModalEditClient/ModalEditClient";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import classes from "./ClientLine.module.scss";

interface IClientLineProps {
  item: IClient;
  editSuccess: Dispatch<SetStateAction<boolean>>;
  deleteSuccess: Dispatch<SetStateAction<boolean>>;
}

export default function ClientLine({
  item,
  editSuccess,
  deleteSuccess,
}: IClientLineProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const windowSize = useWindowSize();
  const [modalEditShown, modalEditToggle] = useState(false);
  const [modalDeleteShown, modalDeleteToggle] = useState(false);
  const { pageSize } = useAppSelector((state) => state.client);

  const deleteHandler = async () => {
    const isDeleted = await dispatch(deleteClient(item.client_uuid));

    if (isDeleted) {
      modalDeleteToggle(false);
      deleteSuccess(true);
      dispatch(setCurrentPage(1));
      await dispatch(fetchClients({ page: 1, pageSize }));
    }
  };

  const modalEdit = modalEditShown && (
    <ModalEditClient
      close={() => modalEditToggle(false)}
      editSuccess={editSuccess}
      editableItem={item}
    />
  );

  const modalDelete = modalDeleteShown && (
    <Modal
      title={"Удалить клиента?"}
      close={() => modalDeleteToggle(false)}
      dialogSizeSuffix={"w350"}
      submitClick={deleteHandler}
      submitText={"Да, удалить"}
      cancelClick={() => modalDeleteToggle(false)}
      headerAlignCenter={true}
    />
  );

  const menuList = [
    {
      id: 1,
      text: "Просмотр",
      onClick: () => navigate(`client/${item.client_uuid}`),
    },
    {
      id: 2,
      text: "Редактировать",
      onClick: () => modalEditToggle(true),
    },
    {
      id: 3,
      text: "Удалить",
      type: "delete",
      onClick: () => modalDeleteToggle(true),
    },
  ];

  const formattedBirthday = dayjs(item.birthday, "YYYY-MM-DD").format(
    "DD.MM.YYYY"
  );

  return (
    <>
      <div className={classes.wrap}>
        <div className={[classes.field, classes.field_name].join(" ")}>
          <div className={classes.field_value}>{item.fio}</div>
          {/*      {windowSize.width < 992 && (
            <div className={classes.field_label}>{formattedBirthday}</div>
          )}*/}
        </div>
        {/*     {windowSize.width >= 992 && (
          <div className={classes.field}>
            <span>{formattedBirthday}</span>
          </div>
        )} */}
        {item.height && (
          <div className={classes.field}>
            {windowSize.width < 992 && (
              <div className={classes.field_label}>Рост</div>
            )}
            {windowSize.width >= 992 && (
              <div className={classes.field_value}>
                {item.height ? `${item.height}` : `-`}
              </div>
            )}
            {windowSize.width < 992 && (
              <div className={classes.field_value}>
                <span>{item.height ? `${item.height} см` : `-`}</span>
              </div>
            )}
          </div>
        )}
        <div className={classes.field}>
          {windowSize.width < 992 && (
            <div className={classes.field_label}>Вес</div>
          )}
          {windowSize.width >= 992 && (
            <div className={classes.field_value}>
              {item.weight ? `${item.weight}` : `-`}
            </div>
          )}
          {windowSize.width < 992 && (
            <div className={classes.field_value}>
              <span>{item.weight ? `${item.weight} кг` : `-`}</span>
            </div>
          )}
        </div>
        <div className={classes.field}>
          {windowSize.width < 992 && (
            <div className={classes.field_label}>Телефон</div>
          )}
          <div className={classes.field_value}>
            {item.phone ? `${item.phone}` : `-`}
          </div>
        </div>
        <div className={[classes.field, classes.field_menu].join(" ")}>
          <LineMenu items={menuList} />
        </div>
      </div>
      {modalEdit}
      {modalDelete}
    </>
  );
}
